<template>
  <div v-bind:class="amplifyUI.formSection" class="login-form">
    <div v-bind:class="amplifyUI.sectionHeader">{{options.header}}</div>
    <div v-bind:class="amplifyUI.sectionBody">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Username')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="username"
          :placeholder="$Amplify.I18n.get('Enter your username')"
          autofocus
          autocomplete="new-username"
          @keyup.enter="submit"
        />
      </div>
      <div v-bind:class="amplifyUI.formField" v-if="sent">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Code')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="code"
          autocomplete="new-code"
          :placeholder="$Amplify.I18n.get('Code')"
          autofocus
        />
      </div>
      <div v-bind:class="amplifyUI.formField" v-if="sent">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('New Password')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="password"
          type="password"
          autocomplete="new-pass"
          :placeholder="$Amplify.I18n.get('New Password')"
        />
        <div
          class="bottom-margin v-messages theme--light v-messages__message"
        >At least 8 characters, 1 number, 1 lowercase and 1 uppercase letter</div>
      </div>
      <div v-bind:class="amplifyUI.formField" v-if="sent">
        <div v-bind:class="amplifyUI.inputLabel">Confirm Password</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="password2"
          type="password"
          autocomplete="new-pass2"
          :placeholder="$Amplify.I18n.get('New Password')"
          @keyup.enter="verify"
        />
      </div>
    </div>

    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <v-btn
          v-if="!sent"
          v-bind:class="amplifyUI.button"
          v-on:click="submit"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Send Code')}}</v-btn>
        <v-btn
          v-if="sent"
          v-bind:class="amplifyUI.button"
          v-on:click="verify"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Submit')}}</v-btn>
      </span>
      <span v-bind:class="amplifyUI.sectionFooterSecondaryContent">
        <a v-if="!sent" v-bind:class="amplifyUI.a" v-on:click="sent = true">I have a code</a>
        <a
          v-if="sent"
          v-bind:class="amplifyUI.a"
          v-on:click="submit"
        >{{$Amplify.I18n.get('Resend Code')}}</a>
      </span>
    </div>
    <div class="forgotError" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import { mapState } from "vuex";
export default {
  name: "ForgotPassword",
  props: ["forgotPasswordConfig"],
  data() {
    return {
      username: "",
      buttonLoad: false,
      code: "",
      password: "",
      password2: "",
      error: "",
      sent: false,
      logger: {},
      amplifyUI: AmplifyUI
    };
  },
  watch: {
    resetUser() {
      this.username = this.resetUser;
    }
  },
  computed: {
    ...mapState("user", [
      "resetUser",
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle"
    ]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    options() {
      const defaults = {
        // header: this.retirementBranded
        //   ? "Reset Retirement Account Access"
        //   : this.mersBranded
        //   ? "Reset MERS Account Access"
        //   : "Reset MY ALERUS password"
        header: "Reset Password"
      };
      return Object.assign(defaults, this.forgotPasswordConfig || {});
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    async submit() {
      this.buttonLoad = true
      await this.$Amplify.Auth.forgotPassword(this.username.toLowerCase())
        .then(({ CodeDeliveryDetails: { Destination } }) => {
          // create log for password reset code
          this.$store.dispatch("user/createLog", {
            username: this.username.toLowerCase(),
            log: "ResetPasswordCode",
            app: "MyAlerus"
          });
          this.error = `A verification code has been sent to ${Destination}.`;
          this.sent = true;
          this.logger.info("forgotPassword success");
        })
        .catch(e => {
          var registerDate = this.mersBranded ? "4/7/2020" : "9/17/19";
          var signUpText = this.mersBranded ? "Create Account" : "Sign Up";
          if (
            e.message === "User password cannot be reset in the current state."
          ) {
            this.setError("Please sign in first to continue");
          } else if (
            e.message === "UserMigration failed with error no user found."
          ) {
            this.setError(
              "Username not found. Please select Create Account from the Sign In screen."
            );
          } else if (
            e.message ===
            "UserMigration failed with error Cannot read property 'agreedTerms' of null."
          ) {
            this.setError(
              "Due to the enhanced security measures added on " +
                registerDate +
                ", you will need to re-create your account by selecting " +
                signUpText +
                "."
            );
          } else {
            this.setError(e);
          }
        });
      this.buttonLoad = false
    },
    async verify() {
      this.error = "";
      if (this.password !== this.password2) {
        this.error = "Password does not match";
        return;
      }
      this.buttonLoad = true
      await this.$Amplify.Auth.forgotPasswordSubmit(
        this.username.toLowerCase(),
        this.code,
        this.password
      )
        .then(async () => {
          // create password reset log
          this.$store.dispatch("user/createLog", {
            username: this.username.toLowerCase(),
            log: "ResetPassword",
            app: "MyAlerus"
          });
          this.$store.commit("user/setAdminReset", false);
          await this.$Amplify.Auth.signIn(this.username.toLowerCase(), this.password)
            .then(newUser => {
              // create successful sign in attempt log
              // this.$store.dispatch("user/createLog", {
              //   username: this.username.toLowerCase(),
              //   log: "SignIn",
              //   app: "MyAlerus"
              // });
              this.$store.commit("user/setUser", newUser);
              // this.$store.commit("user/setState", "signedIn");
              return AmplifyEventBus.$emit("authState", "signedIn");
            })
            .catch(err => {
              this.setError(err);
              return AmplifyEventBus.$emit("authState", "signedOut");
            });

          // this.logger.info("forgotPasswordSubmit success");
          // AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(e => {
          this.setError(e);
        });
      this.buttonLoad = false
    },
    signIn: function() {
      AmplifyEventBus.$emit("authState", "signedOut");
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    }
  }
};
</script>

<style>
.login-form input {
  border: 1px solid lightgray;
}
.forgotError {
  color: red;
  margin-top: 1rem;
}
.bottom-margin {
  margin-bottom: 10px;
}
.load-button {
  border-radius: 0 !important;
  .v-btn__content {
    font-size: inherit !important;
  }
}
</style>
